export default "__VITE_ASSET__BhmZlNFV__"